import React from 'react';
import { skillGroups } from '../mock';
import { CheckCircle2 } from 'lucide-react';
import BackToTop from './BackToTop';

const SkillCard = ({ group, index }) => (
  <div className="group relative bg-[#07111f] border border-white/10 p-7 hover:border-[#c9a961]/60 transition-colors duration-300">
    <div className="flex items-baseline justify-between">
      <h3 className="font-display text-xl text-white">{group.category}</h3>
      <span className="font-display text-[#c9a961] text-sm">0{index + 1}</span>
    </div>
    <div className="h-px bg-white/10 my-5 group-hover:bg-[#c9a961]/40 transition-colors" />
    <ul className="space-y-3">
      {group.items.map((it) => (
        <li key={it} className="flex items-start gap-3 text-[15px] text-white/80">
          <CheckCircle2 size={16} className="text-[#c9a961] mt-1 shrink-0" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  </div>
);

const SkillsHeader = () => (
  <div className="max-w-3xl">
    <div className="section-eyebrow">Capabilities</div>
    <h2 className="font-display text-4xl md:text-5xl mt-4">
      A full-spectrum toolkit, refined across regulated industries.
    </h2>
    <div className="gold-line mt-6" />
    <p className="text-white/70 mt-6 max-w-2xl leading-relaxed">
      Strategy and storytelling for stakeholders. Frameworks and rigor for engineers. The
      following capabilities have been honed across portfolio platforms, capital markets and
      regulatory programs.
    </p>
  </div>
);

const Skills = () => (
  <section id="skills" className="bg-[#0c1a2b] text-white py-24 lg:py-32 relative overflow-hidden">
    <div
      className="absolute inset-0 opacity-[0.05] pointer-events-none"
      style={{
        backgroundImage:
          'linear-gradient(rgba(201,169,97,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(201,169,97,0.3) 1px, transparent 1px)',
        backgroundSize: '64px 64px',
      }}
    />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
      <SkillsHeader />
      <div className="mt-14 grid md:grid-cols-2 gap-6">
        {skillGroups.map((g, i) => (
          <SkillCard key={g.category} group={g} index={i} />
        ))}
      </div>
      <BackToTop targetId="skills" label="Top of Skills" variant="dark" className="mt-16" />
    </div>
  </section>
);

export default Skills;
